import { Label, Value } from '@issuemanager/apps/client/components';
import { Stack, StackProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ViewIssueAvatar from './ViewIssueAvatar';
import ViewIssueUserName from './ViewIssueUserName';

interface Props {
  name?: string;
  labelText: string;
  testId?: string;
  stackProps?: StackProps;
  initials?: string | null;
  isVisible?: boolean;
}

export default function ({
  name,
  labelText,
  testId,
  stackProps,
  initials,
  isVisible = true,
}: Props) {
  const { t } = useTranslation('issue');
  const title = !name ? t('view.labels.title', { labelText }) : undefined;

  if (!isVisible) return null;

  return (
    <Stack direction='row' spacing={1} alignItems='center' {...stackProps}>
      {name && <ViewIssueAvatar name={name} size='small' initials={initials} />}
      <div title={title}>
        <Label>{labelText}</Label>
        {name ? (
          <ViewIssueUserName name={name} block testId={testId} />
        ) : (
          <Value testId={testId}>-</Value>
        )}
      </div>
    </Stack>
  );
}
